import React, { useState } from 'react';
import Sidebar from '../Sidebar/Sidebar';
import styles from './Layout.module.css';

const Layout = ({ children, fullWidth = false }) => {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  const closeSidebar = () => {
    setSidebarOpen(false);
  };

  return (
    <div className={styles.layout}>

      <header className={styles.header}>
        <span className={styles.title}>Inriser</span>
        <button
          className={styles.hamburger}
          onClick={toggleSidebar}
        >
          ☰
        </button>
      </header>

      <Sidebar isOpen={sidebarOpen} onClose={closeSidebar} />
      <main className={styles.main}>
        <div className={styles.content} style={fullWidth ? { maxWidth: '100%' } : {}}>
          {children}
        </div>
      </main>
    </div>
  );
};

export default Layout;
